import uuid from 'uuid/v4'

import { updateHubspotContact, submitScheduleViewingRequestForm } from '../../utils/hubspot'
import firebase, { firestore } from '../../utils/firebase'
import { logError } from '../../utils/bugsnag'

export const TOGGLE_SCHEDULE_VIEWING_MODAL = 'TOGGLE_SCHEDULE_VIEWING_MODAL'
export const RECEIVED_VIEWINGS = 'RECEIVED_VIEWINGS'

export const toggleScheduleViewingModal = bool => {
  return {
    type: TOGGLE_SCHEDULE_VIEWING_MODAL,
    bool
  }
}

export const receivedViewingRequests = viewingRequests => {
  return {
    type: RECEIVED_VIEWINGS,
    viewingRequests
  }
}

export const openScheduleViewing = () => {
  return async (dispatch, getState) => {
    dispatch(toggleScheduleViewingModal(true))
  }
}

export const createViewingRequest = (property, data) => {
  return async (dispatch, getState) => {
    const { firebaseUser } = getState().auth
    const { viewingRequests } = getState().schedule
    const { cookieUser } = getState().session

    const firebaseOrCookieUser = firebaseUser || cookieUser

    if (!firebaseOrCookieUser) {
      logError('firebaseOrCookieUser not found', true)
      return
    }

    submitScheduleViewingRequestForm({
      ...data,
      user: {
        first_name: firebaseOrCookieUser.firstName,
        last_name: firebaseOrCookieUser.lastName,
        phone: firebaseOrCookieUser.phone,
        email: firebaseOrCookieUser.email
      }
    })

    updateHubspotContact({
      city: property.address.city,
      state: property.address.state
    }, firebaseOrCookieUser.email)

    if (viewingRequests.get(property.id)) return

    const viewingRequestId = uuid()

    const newViewingRequest = {
      id: viewingRequestId,
      userId: firebaseOrCookieUser.id,
      propertyId: property.id,
      note: data.note,
      movingDate: data.movingDate,
      createdAt: firebase.firestore.FieldValue.serverTimestamp()
    }

    await Promise.all([
      firestore
        .collection('viewing_requests')
        .doc(viewingRequestId)
        .set(newViewingRequest),

      firestore
        .collection('users')
        .doc(firebaseOrCookieUser.id)
        .update({
          'scheduling.movingDate': data.movingDate
        })
    ])
  }
}
